export const UPDATE_DEDICATED_STATUS_LIST = 'UPDATE_DEDICATED_STATUS_LIST';
export const UPDATE_DEDICATED_STATUS_LIST_ERROR ='UPDATE_DEDICATED_STATUS_LIST_ERROR';
export const UPDATE_DEDICATED_STATUS_RECORD = 'UPDATE_DEDICATED_STATUS_RECORD';